import { Dispatch } from "redux";
import {
    resetFormValues,
    UpsertScheduleQualificationModalInterface,
    setError,
    setIsPatchEditScheduledQualificationSuccess,
    setIsScheduleQualificationModalOpen,
} from "../UpsertScheduleQualificationModalSlice";
import { toast } from "react-toastify";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { useEditScheduledQualificationMutation } from "../../../common/api/scheduledQualification";
import { ScheduledQualificationStatusEnum } from "../../../common/enums/ScheduledQualificationStatusEnum";

interface Props {
    formValues?: UpsertScheduleQualificationModalInterface["formValues"];
    editScheduleQualification: ReturnType<
        typeof useEditScheduledQualificationMutation
    >[0];
    dispatch: Dispatch;
}

export const handleEditScheduledQualification = async (
    props: Props,
): Promise<void> => {
    const { formValues, editScheduleQualification, dispatch } = props;
    if (!formValues || !formValues.employeeScheduledQualificationId) return;

    try {
        await editScheduleQualification({
            id: formValues.employeeScheduledQualificationId,
            data: {
                qualification_id: formValues.qualification?.value,
                employee_ids: [formValues.employee?.value],
                educator_id: formValues.educator?.value,
                starts_at: formValues.startDate,
                ends_at: formValues.endDate,
                status: ScheduledQualificationStatusEnum.SCHEDULED,
            },
        }).unwrap();

        dispatch(setIsScheduleQualificationModalOpen(false));
        dispatch(setIsPatchEditScheduledQualificationSuccess(true));
        dispatch(resetFormValues());
        toast.success("Kwalificatie is bijgewerkt");
    } catch (error) {
        const errorData = error as ErrorInterface;
        dispatch(setError(errorData?.data?.message ?? "Onbekende fout"));
    }
};
